import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { push } from "connected-react-router";

import Modal from "../../ui/Modals/ModalWindow";
import PollForm from "../../ui/PollForm/PollForm";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";

import { getEditingPollAsync, editPollAsync, clearPollForm } from "../../../redux/actions/editPoll";
import { openCancelModal, closeCancelModal } from "../../../redux/actions/ui";

const mapStateToProps = state => ({
  ...state.editPoll,
  cancelModal: state.ui.cancelModal,
});

const mapDispatchToProps = dispatch => ({
  openCancelModal: () => dispatch(openCancelModal()),
  closeCancelModal: () => dispatch(closeCancelModal()),
  onGoBack: pollId => dispatch(push(`/poll/${pollId}`)),
  clearForm: () => dispatch(clearPollForm()),
  editPoll: pollId => dispatch(editPollAsync(pollId)),
  getPollInfo: pollId => dispatch(getEditingPollAsync(pollId)),
});

class EditPoll extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    poll: PropTypes.object.isRequired,
    onGoBack: PropTypes.func.isRequired,
    cancelModal: PropTypes.object.isRequired,
    openCancelModal: PropTypes.func.isRequired,
    closeCancelModal: PropTypes.func.isRequired,
    clearForm: PropTypes.func.isRequired,
    editPoll: PropTypes.func.isRequired,
    getPollInfo: PropTypes.func.isRequired,
  };

  componentDidMount = () => {
    const { getPollInfo } = this.props;
    const pollId = this.props.match.params.pollId;
    getPollInfo(pollId);
  }

  closeModalAndGo = () => {
    const { closeCancelModal, onGoBack, clearForm } = this.props;
    const pollId = this.props.match.params.pollId;
    closeCancelModal();
    clearForm();
    onGoBack(pollId);
  }

  render() {
    const {
      ready,
      loading,
      poll,
      cancelModal,
      openCancelModal,
      closeCancelModal,
      editPoll,
    } = this.props;

    return (
      <div className="page-wrapper"> 
         <Modal
          confirmText="Остаться"
          cancelText="Покинуть страницу"
          modal={cancelModal}
          onSubmit={() => closeCancelModal()}
          onCancel={() => this.closeModalAndGo()}
         />
        <div className="page-header">
          {ready ? (
            <button type="button" className="btn btn-back" onClick={() => openCancelModal()}>
              <i aria-hidden="true" className="back-icon icon" />
              <span>Назад</span>
            </button>
          ) : false}
        </div>
        
        <div className="page-content forms">
          <div className="form-header">Редактирование опроса</div>
          {ready ? (
            <PollForm
              edit
              poll={poll}
              submitText="Сохранить изменения"
              onSubmit={() => editPoll(poll.id)}
            />
          ) : false}
          {loading ? (<Spinner />) : false}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(EditPoll));
